import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { ButtonReset } from '@helpers/global';
import { Layers } from '@helpers/layers';
import { Device, from } from '@helpers/media';
import scrollbars from '@helpers/scrollbars';
import styled from 'styled-components';
const Container = styled.nav `
  ${transition('transform', 0.66)};

  position: fixed;
  z-index: ${Layers.NavigationTray};
  top: var(--headerHeight);
  left: 0;
  height: calc(100% - var(--headerHeight));
  width: 100%;
  background-color: ${brand.primary.purple};

  &[data-active='closed'] {
    transform: translateX(100%);
  }

  &[data-active='child-open'] {
    transform: translateX(-100%);
  }

  @media ${from(Device.TabletLarge)} {
    display: none;
  }
`;
const Inner = styled.div `
  padding: 80px ${fluid(22, 246, Device.Mobile, Device.TabletLarge)} 30px;
  height: 100%;
`;
const Scroll = styled.div `
  ${scrollbars};

  overflow: auto;
  height: 100%;
  padding-right: 24px;

  &[data-child='true'] {
    height: calc(100% - 58px);
  }
`;
const Bottom = styled.div `
  border-top: 1px solid ${brand.secondary.red};
  margin: 22px 0 0;
  padding: 25px 0 0;
`;
const ButtonsWrapper = styled.div `
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  margin: 27px 0 0;
`;
const LinkGroup = styled.div `
  margin: 0 0 28px;
`;
const Link = styled.a `
  ${ButtonReset};
  ${fonts.graphikCompact.medium};

  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: 24px;
  color: ${brand.primary.offWhite};
  font-size: 18px;
  line-height: 24px;
  text-decoration: none;
  text-align: left;
  margin: 0 0 20px;

  > svg {
    display: block;
    height: 12px;
    min-width: 8px;
    max-width: 8px;
  }

  button& {
    ${transition('transform', 0.15)};

    &.focus-ring,
    &:active {
      transform: translateY(1.5px);
    }
  }

  ${LinkGroup} & {
    font-size: 16px;
    line-height: 20px;
    margin-bottom: 16px;

    &:not(:first-child) {
      ${fonts.graphikCompact.regular};
    }
  }

  &[data-highlight='true'] {
    color: ${brand.secondary.red};
    font-size: 18px;
    line-height: 24px;
  }
`;
const BackButton = styled.button `
  ${ButtonReset};
  ${transition('transform', 0.15)};
  ${fonts.graphikCompact.medium};

  display: inline-flex;
  align-items: center;
  width: 100%;
  gap: 24px;
  color: ${brand.primary.offWhite};
  font-size: 16px;
  line-height: 20px;
  margin: 0 0 36px;

  > svg {
    display: block;
    height: 12px;
    transform: rotate(180deg);
  }

  &.focus-ring,
  &:active {
    transform: translateY(1.5px);
  }
`;
const MobileNavigationStyles = {
    BackButton,
    Bottom,
    ButtonsWrapper,
    Container,
    Inner,
    Link,
    LinkGroup,
    Scroll,
};
export default MobileNavigationStyles;
